import { toast } from 'react-toastify';
import store from '../store';
import { resetAuth } from '../store/slices/auth';

let isLoggingOut = false;

/**
 * Checks if an HTTP status or response payload indicates an expired token or unauthorized access.
 */
export const isUnauthorizedPayload = (data, status) => {
  if (status === 401 || status === 403) return true;
  if (!data) return false;

  const statusCode = data.StatusCode !== undefined ? Number(data.StatusCode) : null;
  if (statusCode === 401 || statusCode === 403) return true;

  const resultStr = typeof data.Result === 'string' ? data.Result.toLowerCase() : '';
  const messageStr = typeof data.Message === 'string' ? data.Message.toLowerCase() : '';

  if (
    resultStr.includes('authkey expired') ||
    resultStr.includes('token expired') ||
    resultStr.includes('unauthorized')
  ) {
    return true;
  }

  if (
    messageStr.includes('authkey expired') ||
    messageStr.includes('token expired') ||
    messageStr.includes('unauthorized')
  ) {
    return true;
  }

  return false;
};

/**
 * Handles automatic logout when session/AuthKey expires.
 * Clears localStorage, resets Redux auth state, displays a notification, and redirects to /login.
 */
export const handleUnauthorized = () => {
  if (isLoggingOut) return;
  isLoggingOut = true;

  toast.error('Session expired. Please log in again.');

  const biometricKeys = [
    'biometric_credentials',
    'biometric_crypto_key',
    'biometric_enrolled',
    'biometric_credential_id',
    'biometric_token',
  ];
  const keysToRemove = [];
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && !biometricKeys.includes(key)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
    sessionStorage.clear();
  } catch (e) {
    console.error('Error clearing storage:', e);
  }

  try {
    if (store && store.dispatch) {
      store.dispatch(resetAuth());
    }
  } catch (err) {
    console.error('Error resetting auth state:', err);
  }

  setTimeout(() => {
    isLoggingOut = false;
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  }, 1000);
};
